import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {Player} from 'video-react';
import Video from '../assets/FinalVideoIntro.mp4'
import Poster from '../assets/Poster.png'

import '../App.css'
import '../styles/container.scss'
import '../styles/main.scss'
import '../styles/neighborhood.scss'
import '../styles/mapkey.scss'
import '../styles/splash.scss'
import image from '../assets/demo.png'

import 'video-react/dist/video-react.css';

class Splash extends React.Component{

    componentDidMount(){
        this.player.playbackRate = 1.5;
    }

    render(){
        return(
        <div className="splash" id="splash">

            <div className="splash-icons">
                <FontAwesomeIcon icon={['far', 'map']} className="icon-spacing"/>
                <FontAwesomeIcon icon={['fa', 'map-marker-alt']} className="icon-spacing"/>
                <FontAwesomeIcon icon={['fa', 'stamp']} className="icon-spacing"/>
                <FontAwesomeIcon icon={['fa', 'vector-square']} className="icon-spacing"/>
                <FontAwesomeIcon icon={['fa', 'building']} className="icon-spacing"/>
            </div>

                <br/>
                    <div id="video-box">
                        <Player 
                            ref={(player) => {this.player = player}}
                            playsInline
                            poster={Poster}
                            >
                            <source src={Video} />
                        </Player>
                    </div>
                <br/>
                    <div className="splash-text">
                    <h1>Start Design Research Here.</h1>
                    <h4 className="para-desc">Find preliminary information on maps, neighborhoods, zoning, and existing <br/>
                    buildings in New York, for your next design or development project. Powered by NYC Open Data.</h4>
                    </div>
                <br/>   
            <div className="splash-buttons">
                <button className="splash-btn-in" value="remove-splash" onClick={this.props.onClick}> Launch Viewer</button>
                <button className="splash-btn-in" value="add-about" onClick={this.props.onClick} id="sign-up">About This Project</button>
            </div>

        </div>
    )

    }
    
}
export default Splash